// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project-imports
import chat from './chat';
import calendar from './calendar';
import menu from './menu';
import snackbar from './snackbar';
import productReducer from './product';
import cartReducer from './cart';
import kanban from './kanban';
import invoice from './invoice';
import user from './user'; // Import the user reducer\
import projectView from './projectView';
import user_Management from './user_Management';
import VisitorDetails from './VisitorDetails';
import SalesManagerCustomer from './SalesManagerCustomer';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
  chat,
  calendar,
  menu,
  snackbar,
  cart: persistReducer(
    {
      key: 'cart',
      storage,
      keyPrefix: 'able-pro-material-ts-'
    },
    cartReducer
  ),
  product: productReducer,
  kanban,
  invoice,
  user,
  projectView, // Add the user reducer
  user_Management,
  VisitorDetails,
  SalesManagerCustomer
});

export default reducers;
